import { useMemo } from 'react'

type SlotMachineProps = {
  columns?: number
  speed?: number
}

export default function SlotMachine({ columns = 3, speed = 8 }: SlotMachineProps) {
  const images = [
    '/templates/1.jpg',
    '/templates/2.jpg',
    '/templates/3.jpg',
    '/templates/4.jpg',
    '/templates/5.jpg',
    '/templates/6.jpg',
    '/templates/7.jpg',
    '/templates/8.jpg',
    '/templates/9.jpg',
    '/templates/10.jpg',
    '/templates/11.jpg',
    '/templates/12.jpg',
    '/templates/13.jpg',
    '/templates/14.jpg',
    '/templates/15.jpg',
    '/templates/16.jpg',
    '/templates/17.jpg',
    '/templates/18.jpg',
    '/templates/19.jpg',
    '/templates/20.jpg',
    '/templates/21.jpg',
    '/templates/22.jpg',
    '/templates/23.jpg',
    '/templates/24.jpg',
    '/templates/25.jpg',
    '/templates/26.jpg',
    '/templates/27.jpg',
    '/templates/28.jpg',
    '/templates/29.jpg',
    '/templates/30.jpg',
  ]

  const cols = useMemo(() => {
    const shuffledImages = [...images].sort(() => Math.random() - 0.5)
    const chunkSize = Math.ceil(shuffledImages.length / columns)

    return Array.from({ length: columns }).map((_, colIdx) => {
      const start = colIdx * chunkSize
      const end = start + chunkSize
      return {
        items: shuffledImages.slice(start, end),
        reverse: colIdx % 2 === 1,
      }
    })
  }, []) // empty deps: memoized once on mount

  return (
    <div className="flex w-full h-full overflow-hidden">
      {cols.map((col, idx) => (
        <div key={idx} className="flex-1 overflow-hidden relative">
          <div
            className="absolute top-0 left-0 w-full animate-slot"
            style={{
              animationDuration: `${speed}s`,
              animationDirection: col.reverse ? 'reverse' : 'normal',
            }}
          >
            {[...col.items, ...col.items].map((src, i) => (
              <div key={i} className="p-3">
                <div className="w-full aspect-[9/16] border border-gray-100 rounded-lg overflow-hidden bg-white">
                  <img src={src} alt="slot" className="w-full h-full object-cover" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
